/**
 * Bundle Picker — interactive controller
 * Supports: buttons mode, dropdown mode, expanded/collapsed start,
 *           discounted price rendering, cart count in add button.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.BundlePicker').forEach(init);
  });
  function init(root) {
    if (!root) return;

    var mode       = root.getAttribute('data-tier-mode')   || 'buttons';
    var showDisc   = root.getAttribute('data-show-disc')   !== 'false';
    var cardsOpen  = root.getAttribute('data-cards-open')  === 'true';
    var customise  = root.getAttribute('data-customise')   === 'true';
    var catExpanded = root.getAttribute('data-cat-expanded') !== 'false';
    var allowMulti  = root.getAttribute('data-multi')        !== 'false';
    var ingOn       = root.getAttribute('data-ing')          !== 'false';
    var ingOnHover  = root.getAttribute('data-ing-hover')    !== 'false';
    // Straight-to-cart: a card's Add button puts that product in the cart there and
    // then, so the shopper never presses Add and then Add to cart as well. Customise
    // mode still ends at one button (its steppers build a single order), so the two
    // are mutually exclusive.
    var instantAdd  = root.getAttribute('data-instant-add')  === 'true' && !customise;
    var openDrawer  = root.getAttribute('data-open-drawer')  === 'true';
    var cartUrl     = root.getAttribute('data-cart-url')     || '/cart';
    var saveAmount  = root.getAttribute('data-save-amount')   === 'true';
    var tapCard     = root.getAttribute('data-tap-card')     !== 'false';

    var track      = root.querySelector('.BundlePicker__Track');
    var footer     = root.querySelector('.BundlePicker__Footer');
    var countEl    = root.querySelector('.BundlePicker__Count');
    var addBtn     = root.querySelector('.BundlePicker__AddBtn');

    var summaryEl   = root.querySelector('.BundlePicker__Summary');
    var sumTotalEl  = root.querySelector('.BundlePicker__SummaryTotal');
    var sumWasEl    = root.querySelector('.BundlePicker__SummaryWas');
    var sumSaveEl   = root.querySelector('.BundlePicker__SummarySave');
    var sumHintEl   = root.querySelector('.BundlePicker__SummaryHint');

    var customiseWrap = root.querySelector('.BundlePicker__Customise');
    var customToggle  = root.querySelector('.BundlePicker__CustomiseToggle');
    var customList    = root.querySelector('.BundlePicker__CustomList');
    var catGroups     = root.querySelectorAll('.BundlePicker__CatGroup'); // defined early: openCatGroup() runs during activateTier() before the category section below

    // Every pack the merchant configured, smallest first. Quantity drives which
    // one applies — the shopper is never capped at the pack they clicked.
    var tiers = [];
    root.querySelectorAll(mode === 'dropdown' ? '.BundlePicker__DropItem' : '.BundlePicker__Tier')
        .forEach(function (el) {
          var q = parseInt(el.getAttribute('data-qty') || '0', 10);
          if (q > 0) tiers.push({ qty: q, disc: parseInt(el.getAttribute('data-disc') || '0', 10),
                                  code: el.getAttribute('data-discount-code') || '', el: el });
        });
    tiers.sort(function (a, b) { return a.qty - b.qty; });
    var minTierQty = tiers.length ? tiers[0].qty : 0;

    // The biggest pack the shopper has actually reached. Going beyond the largest
    // pack keeps that pack's rate rather than dropping the discount.
    function earnedTier(total) {
      var found = null;
      tiers.forEach(function (t) { if (total >= t.qty) found = t; });
      return found;
    }
    function nextTier(total) {
      for (var i = 0; i < tiers.length; i++) { if (tiers[i].qty > total) return tiers[i]; }
      return null;
    }

    var activeDisc   = 0;   // discount % for active tier
    var activeCode   = '';  // discount code for active tier
    var cardQtys     = {};  // variantId -> quantity chosen (card mode)
    var customQtys   = {};  // variantId -> quantity (customise mode)

    // Total across every card, used to enforce the tier's pack size.
    function cardTotal() {
      var t = 0;
      Object.keys(cardQtys).forEach(function (id) { t += cardQtys[id]; });
      return t;
    }

    // ── Expand / collapse helpers ────────────────────────────────────────────
    function showTrack(show) {
      if (!track) return;
      track.style.display = show ? 'flex' : 'none';
    }
    function showFooter(show) {
      if (!footer) return;
      footer.style.display = show ? 'flex' : 'none';
    }

    // Initially hide/show based on setting
    // Categories mode: always show the track — the category headers are the navigation
    var isCategories = track && track.classList.contains('BundlePicker__Track--categories');
    showTrack(cardsOpen || isCategories);
    showFooter(cardsOpen || isCategories);

    // ── Price update on cards ─────────────────────────────────────────────────
    function updateCardPrices(discPct) {
      if (!showDisc) return;
      root.querySelectorAll('.BundlePicker__Card').forEach(function (card) {
        var origCents = parseInt(card.getAttribute('data-price') || '0', 10);
        var priceEl   = card.querySelector('.BundlePicker__CardPrice');
        var wasEl     = card.querySelector('.BundlePicker__CardWas');
        if (!priceEl) return;
        if (discPct > 0) {
          var discAmt   = Math.ceil(origCents * discPct / 100);
          var saleCents = origCents - discAmt;
          priceEl.textContent = formatMoney(saleCents);
          priceEl.classList.add('BundlePicker__CardPrice--sale');
          if (wasEl) {
            wasEl.textContent = formatMoney(origCents);
            wasEl.style.display = '';
          }
        } else {
          priceEl.textContent = formatMoney(origCents);
          priceEl.classList.remove('BundlePicker__CardPrice--sale');
          if (wasEl) wasEl.style.display = 'none';
        }
      });
    }

    // Simple money formatter (uses Shopify's money_format if available, else cents/100)
    function formatMoney(cents) {
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents, window.Shopify.money_format || '${{amount}}');
      }
      return '$' + (cents / 100).toFixed(2);
    }

    // ── Customise-mode helpers ────────────────────────────────────────────────
    function getSelectedCount() {
      if (customise) {
        var t = 0;
        Object.keys(customQtys).forEach(function (id) { t += customQtys[id]; });
        return t;
      }
      return cardTotal();
    }

    function getCartItems() {
      var src = customise ? customQtys : cardQtys;
      var items = [];
      Object.keys(src).forEach(function (id) {
        if (src[id] > 0) items.push({ id: parseInt(id, 10), quantity: src[id] });
      });
      return items;
    }

    // ── Straight-to-cart plumbing ─────────────────────────────────────────────
    // Only used when "Add straight to cart" is on. All the cart traffic goes
    // through cart-integration.js so the cart bubble, the drawer contents and the
    // sticky cart bar stay in step; `silent` is what stops the drawer sliding over
    // the picker after every single tap.
    var cartSource = root.id || 'bundle-picker';
    function cartOpts() { return { silent: !openDrawer }; }

    // quantity here is a delta — /cart/add.js adds to whatever is already on the line.
    function cartAddOne(variantId) {
      if (typeof window.themeCartAdd !== 'function') return Promise.reject(new Error('cart integration missing'));
      return window.themeCartAdd([{ id: parseInt(variantId, 10), quantity: 1 }], cartSource, cartOpts());
    }
    // /cart/change.js wants the ABSOLUTE quantity, so read the cart and target the
    // line by index — a variant can sit on more than one line if it carries
    // properties, and the index is the only unambiguous handle.
    function cartRemoveOne(variantId) {
      if (typeof window.themeCartGet !== 'function' || typeof window.themeCartChange !== 'function') {
        return Promise.reject(new Error('cart integration missing'));
      }
      return window.themeCartGet().then(function (cart) {
        var line = 0, item = null;
        (cart.items || []).forEach(function (it, i) {
          if (!line && String(it.variant_id) === String(variantId)) { line = i + 1; item = it; }
        });
        if (!line) return null;   // already gone — nothing to undo
        return window.themeCartChange(line, Math.max(0, item.quantity - 1), cartSource, cartOpts());
      });
    }

    // In-flight guard + "Added ✓" flash, keyed by variant so two cards for the same
    // product never fight over the same request.
    var cartBusy    = {};
    var flashTimers = {};

    function setCardBusy(variantId, busy, label) {
      cartBusy[variantId] = busy;
      root.querySelectorAll('.BundlePicker__Card[data-variant-id="' + variantId + '"]')
          .forEach(function (c) {
            var a = c.querySelector('.BundlePicker__CardAdd');
            var m = c.querySelector('.BundlePicker__CardRemove');
            if (a) { a.disabled = busy; if (label) a.textContent = label; }
            if (m) m.disabled = busy;
          });
    }

    // Paint the new count first so the card feels instant, then fire the request and
    // roll the count back if Shopify refuses (sold out, limit reached, network).
    function instantChange(variantId, nextQty, isAdd) {
      if (cartBusy[variantId]) return;
      var prevQty = cardQtys[variantId] || 0;
      clearTimeout(flashTimers[variantId]);

      if (nextQty > 0) { cardQtys[variantId] = nextQty; } else { delete cardQtys[variantId]; }
      paintVariant(variantId);
      updateAddBtn();
      setCardBusy(variantId, true, isAdd ? 'Adding…' : 'Removing…');

      (isAdd ? cartAddOne(variantId) : cartRemoveOne(variantId))
        .then(function () {
          setCardBusy(variantId, false);
          if (!isAdd) { paintVariant(variantId); return; }
          root.querySelectorAll('.BundlePicker__Card[data-variant-id="' + variantId + '"] .BundlePicker__CardAdd')
              .forEach(function (a) { a.textContent = 'Added ✓'; a.classList.add('is-flash'); });
          flashTimers[variantId] = setTimeout(function () {
            root.querySelectorAll('.BundlePicker__Card[data-variant-id="' + variantId + '"] .BundlePicker__CardAdd')
                .forEach(function (a) { a.classList.remove('is-flash'); });
            paintVariant(variantId);
          }, 1400);
        })
        .catch(function () {
          if (prevQty > 0) { cardQtys[variantId] = prevQty; } else { delete cardQtys[variantId]; }
          paintVariant(variantId);
          updateAddBtn();
          setCardBusy(variantId, false, 'Try again');
          flashTimers[variantId] = setTimeout(function () { paintVariant(variantId); }, 2500);
        });
    }

    function resetSteppers() {
      customQtys = {};
      root.querySelectorAll('.BundlePicker__CustomRow').forEach(function (row) {
        row.classList.remove('is-active');
        var qtyEl = row.querySelector('.BundlePicker__StepQty');
        if (qtyEl) qtyEl.textContent = '0';
      });
      updateStepperStates();
    }

    // Only "−" is ever disabled — there is no upper limit on a bundle.
    function updateStepperStates() {
      root.querySelectorAll('.BundlePicker__CustomRow').forEach(function (row) {
        var id  = row.getAttribute('data-variant-id');
        var qty = customQtys[id] || 0;
        var minus = row.querySelector('.BundlePicker__StepBtn--minus');
        if (minus) minus.disabled = qty <= 0;
      });
    }

    // Apply the active tier discount to the prices shown in the custom list.
    function updateCustomPrices(discPct) {
      if (!showDisc) return;
      root.querySelectorAll('.BundlePicker__CustomRow').forEach(function (row) {
        var orig = parseInt(row.getAttribute('data-price') || '0', 10);
        var el   = row.querySelector('.BundlePicker__CustomPrice');
        if (!el) return;
        if (discPct > 0) {
          var sale = orig - Math.ceil(orig * discPct / 100);
          el.textContent = '';
          var s = document.createElement('s');
          s.textContent = formatMoney(orig);
          var strong = document.createElement('strong');
          strong.textContent = formatMoney(sale);
          el.appendChild(s);
          el.appendChild(document.createTextNode(' '));
          el.appendChild(strong);
        } else {
          el.textContent = formatMoney(orig);
        }
      });
    }

    // ── Activate a tier ───────────────────────────────────────────────────────
    // qty/disc/code are kept in the signature for the existing callers, but the
    // applied discount is derived from what the shopper actually picks.
    function activateTier(qty, disc, code, triggerEl) {
      targetEl = triggerEl || targetEl;

      if (customise) {
        if (customiseWrap) customiseWrap.hidden = false;
        if (customToggle) customToggle.setAttribute('aria-expanded', 'true');
        if (customList) customList.hidden = false;
        showFooter(true);
        updateAddBtn();
        return;
      }

      // Show the product track + footer
      showTrack(true);
      showFooter(true);

      // Auto-expand the first category group in categories mode, but only when the
      // "First category expanded by default" setting is on. With it off every
      // category stays collapsed until the shopper opens one.
      if (catExpanded) {
        var firstCatGrp = root.querySelector('.BundlePicker__CatGroup');
        if (firstCatGrp) {
          openCatGroup(firstCatGrp);
        }
      }

      updateAddBtn();
    }

    // Work out which pack the current quantity qualifies for and apply it — prices,
    // discount code and the highlighted pack button all follow the quantity.
    var targetEl = null;
    function applyEarnedTier() {
      var total  = getSelectedCount();
      var earned = earnedTier(total);
      activeDisc = earned ? earned.disc : 0;
      activeCode = earned ? earned.code : '';

      root.querySelectorAll('.BundlePicker__Tier, .BundlePicker__DropItem').forEach(function (el) {
        el.classList.remove('is-active');
      });
      var highlight = earned ? earned.el : targetEl;
      if (highlight) highlight.classList.add('is-active');

      if (customise) updateCustomPrices(activeDisc);
      else updateCardPrices(activeDisc);

      // Keep the dropdown's closed-state label in step with the pack in force
      if (mode === 'dropdown' && highlight) {
        var dv = root.querySelector('.BundlePicker__DropValue');
        if (dv) {
          var dl = highlight.querySelector('.BundlePicker__DropItemLabel');
          var db = highlight.querySelector('.BundlePicker__DropItemBadge');
          if (dl) dv.textContent = dl.textContent + (db ? '  ' + db.textContent : '');
        }
      }
      return { total: total, earned: earned, next: nextTier(total) };
    }

    // ── Live savings summary ──────────────────────────────────────────────────
    function updateSummary() {
      if (!summaryEl) return;
      var origTotal = 0;
      var saleTotal = 0;
      var count     = 0;

      if (customise) {
        Object.keys(customQtys).forEach(function (id) {
          var q = customQtys[id];
          if (!q) return;
          var row = root.querySelector('.BundlePicker__CustomRow[data-variant-id="' + id + '"]');
          var orig = row ? parseInt(row.getAttribute('data-price') || '0', 10) : 0;
          var discAmt = activeDisc > 0 ? Math.ceil(orig * activeDisc / 100) : 0;
          origTotal += orig * q;
          saleTotal += (orig - discAmt) * q;
          count += q;
        });
      } else {
        Object.keys(cardQtys).forEach(function (id) {
          var q = cardQtys[id];
          if (!q) return;
          var card = root.querySelector('.BundlePicker__Card[data-variant-id="' + id + '"]');
          if (!card) return;
          var orig = parseInt(card.getAttribute('data-price') || '0', 10);
          var discAmt = activeDisc > 0 ? Math.ceil(orig * activeDisc / 100) : 0;
          origTotal += orig * q;
          saleTotal += (orig - discAmt) * q;
          count += q;
        });
      }

      // Nothing chosen yet — hide the row rather than showing a lone dash.
      summaryEl.hidden = count === 0;
      if (count === 0) {
        summaryEl.setAttribute('data-state', 'empty');
        if (sumTotalEl) sumTotalEl.textContent = '—';
        if (sumWasEl)  { sumWasEl.hidden = true; }
        if (sumSaveEl) { sumSaveEl.hidden = true; }
        return;
      }

      var savings = origTotal - saleTotal;
      summaryEl.setAttribute('data-state', 'active');
      if (sumTotalEl) sumTotalEl.textContent = formatMoney(saleTotal);
      if (sumWasEl) {
        if (savings > 0) { sumWasEl.textContent = formatMoney(origTotal); sumWasEl.hidden = false; }
        else { sumWasEl.hidden = true; }
      }
      if (sumSaveEl) {
        if (savings > 0) {
          // The percentage is what makes the next pack look worth it. The dollar
          // figure is opt-in: shown on its own it reads as a discount, shown next
          // to the total it reads as an invitation to compare and hesitate.
          var pct = Math.round(savings / origTotal * 100);
          sumSaveEl.textContent = saveAmount
            ? 'You save ' + formatMoney(savings) + ' (' + pct + '%)'
            : 'You save ' + pct + '%';
          sumSaveEl.hidden = false;
        } else {
          sumSaveEl.hidden = true;
        }
      }
    }

    // ── Selection count + button text ─────────────────────────────────────────
    function updateAddBtn() {
      var state = applyEarnedTier();
      var n = state.total;

      // Below the smallest pack we still show how many are needed; past it the
      // shopper can keep going as long as they like.
      var short = minTierQty > 0 && n < minTierQty;
      if (countEl) {
        if (instantAdd) {
          countEl.textContent = n + ' item' + (n === 1 ? '' : 's') + ' in cart';
        } else {
          countEl.textContent = short ? n + ' / ' + minTierQty + ' selected' : n + ' selected';
        }
      }
      if (addBtn) {
        if (instantAdd) {
          // Everything is already in the cart, so the footer button is a way out
          // rather than a gate — never disabled, never a pack-size requirement.
          addBtn.disabled = false;
          addBtn.textContent = 'View cart';
        } else {
          addBtn.disabled = short || n === 0;
          addBtn.textContent = (short || n === 0)
            ? (minTierQty > 0 ? 'Select ' + minTierQty + ' products' : 'Add to cart')
            : 'Add ' + n + ' item' + (n === 1 ? '' : 's') + ' to cart';
        }
      }
      // Nudge towards the next pack — this is where the extra saving is explained.
      if (sumHintEl) {
        if (state.next && n > 0) {
          var need = state.next.qty - n;
          sumHintEl.textContent = 'Add ' + need + ' more for ' + state.next.disc + '% off';
          sumHintEl.hidden = false;
        } else {
          sumHintEl.textContent = '';
          sumHintEl.hidden = true;
        }
      }
      // Nothing chosen yet — keep the counter and the greyed-out button out of the
      // way rather than showing "0 / 6 selected" before the shopper has started.
      showFooter(n > 0);
      if (customise) updateStepperStates();
      else updateCatCounts();
      updateSummary();
    }

    // ── BUTTONS mode ──────────────────────────────────────────────────────────
    if (mode === 'buttons') {
      root.querySelectorAll('.BundlePicker__Tier').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var qty  = parseInt(btn.getAttribute('data-qty')  || '0', 10);
          var disc = parseInt(btn.getAttribute('data-disc') || '0', 10);
          var code = btn.getAttribute('data-discount-code') || '';
          activateTier(qty, disc, code, btn);
        });
      });
    }

    // ── DROPDOWN mode ─────────────────────────────────────────────────────────
    if (mode === 'dropdown') {
      var dropWrap    = root.querySelector('.BundlePicker__DropWrap');
      var dropTrigger = root.querySelector('.BundlePicker__DropTrigger');
      var dropList    = root.querySelector('.BundlePicker__DropList');
      var dropValue   = root.querySelector('.BundlePicker__DropValue');

      if (dropTrigger && dropList) {
        dropTrigger.addEventListener('click', function () {
          var open = dropTrigger.getAttribute('aria-expanded') === 'true';
          dropTrigger.setAttribute('aria-expanded', open ? 'false' : 'true');
          dropList.classList.toggle('is-open', !open);
        });
        // Close on outside click
        document.addEventListener('click', function (e) {
          if (dropWrap && !dropWrap.contains(e.target)) {
            dropTrigger.setAttribute('aria-expanded', 'false');
            dropList.classList.remove('is-open');
          }
        });
        // Close on Escape key
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && dropTrigger.getAttribute('aria-expanded') === 'true') {
            dropTrigger.setAttribute('aria-expanded', 'false');
            dropList.classList.remove('is-open');
            dropTrigger.focus();
          }
        });
        // Option click
        dropList.querySelectorAll('.BundlePicker__DropItem').forEach(function (item) {
          item.addEventListener('click', function () {
            var qty  = parseInt(item.getAttribute('data-qty')  || '0', 10);
            var disc = parseInt(item.getAttribute('data-disc') || '0', 10);
            var code = item.getAttribute('data-discount-code') || '';
            // Update trigger label
            var label = item.querySelector('.BundlePicker__DropItemLabel');
            var badge = item.querySelector('.BundlePicker__DropItemBadge');
            if (dropValue) dropValue.textContent = (label ? label.textContent : '') + (badge ? '  ' + badge.textContent : '');
            // Close
            dropTrigger.setAttribute('aria-expanded', 'false');
            dropList.classList.remove('is-open');
            activateTier(qty, disc, code, item);
          });
        });
      }
    }

    // ── Customise mode: toggle + quantity steppers ────────────────────────────
    if (customise) {
      if (customToggle && customList) {
        customToggle.addEventListener('click', function () {
          var open = customToggle.getAttribute('aria-expanded') === 'true';
          customToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
          customList.hidden = open;
        });
      }
      if (customList) {
        customList.addEventListener('click', function (e) {
          var btn = e.target.closest('.BundlePicker__StepBtn');
          if (!btn) return;
          var row = btn.closest('.BundlePicker__CustomRow');
          if (!row) return;
          var id   = row.getAttribute('data-variant-id');
          var step = parseInt(btn.getAttribute('data-step') || '0', 10);
          var cur  = customQtys[id] || 0;
          var next = cur + step;
          if (next < 0) next = 0;
          if (next === 0) { delete customQtys[id]; }
          else { customQtys[id] = next; }
          row.classList.toggle('is-active', next > 0);
          var qtyEl = row.querySelector('.BundlePicker__StepQty');
          if (qtyEl) qtyEl.textContent = String(next);
          updateAddBtn();
        });
      }
    }

    // ── Card selection ────────────────────────────────────────────────────────
    // Cards hold a quantity, not a yes/no. Tapping a card adds one more of that
    // product (so a 3-pack can be three of the same scent); the minus control on
    // the card takes one back off. With "allow multiples" off the card falls back
    // to a plain on/off toggle.
    function paintCard(card, qty) {
      var badge  = card.querySelector('.BundlePicker__Check');
      var addBtnEl = card.querySelector('.BundlePicker__CardAdd');
      var remove = card.querySelector('.BundlePicker__CardRemove');
      var title  = card.getAttribute('data-title') || 'this product';

      card.classList.toggle('is-selected', qty > 0);
      // aria-pressed only makes sense while the card itself is the toggle.
      if (!tapCard) card.removeAttribute('aria-pressed');
      else card.setAttribute('aria-pressed', qty > 0 ? 'true' : 'false');
      if (badge) badge.textContent = allowMulti && qty > 1 ? String(qty) : '✓';

      if (addBtnEl) {
        // The button carries the running count, so the shopper can see what is in
        // the bundle (or, in straight-to-cart mode, the cart) without hunting for
        // a badge.
        var where = instantAdd ? 'cart' : 'bundle';
        if (!allowMulti) {
          addBtnEl.textContent = qty > 0 ? (instantAdd ? 'In cart' : 'Added') : 'Add';
          addBtnEl.setAttribute('aria-label', qty > 0
            ? 'Remove ' + title + ' from your ' + where
            : 'Add ' + title + ' to your ' + where);
        } else {
          addBtnEl.textContent = qty > 0
            ? (instantAdd ? 'In cart · ' + qty : 'Add ' + qty)
            : 'Add';
          addBtnEl.setAttribute('aria-label', qty > 0
            ? 'Add another ' + title + '. ' + qty + ' in your ' + where
            : 'Add ' + title + ' to your ' + where);
        }
        addBtnEl.classList.toggle('is-active', qty > 0);
      }
      if (remove) remove.hidden = qty <= 0;
    }

    function paintVariant(variantId) {
      var qty = cardQtys[variantId] || 0;
      root.querySelectorAll('.BundlePicker__Card[data-variant-id="' + variantId + '"]')
          .forEach(function (c) { paintCard(c, qty); });
    }

    function clearCards() {
      cardQtys = {};
      root.querySelectorAll('.BundlePicker__Card').forEach(function (c) { paintCard(c, 0); });
      updateCatCounts();
    }

    function bumpCard(card, step) {
      var variantId = card.getAttribute('data-variant-id');
      if (!variantId) return;
      var cur = cardQtys[variantId] || 0;

      // Straight to cart: every tap is a real cart request, so work out the target
      // quantity here and let instantChange() own the optimistic paint + rollback.
      if (instantAdd) {
        if (!allowMulti) {
          // One of each: tapping an added card takes it back out of the cart.
          if (cur > 0) { instantChange(variantId, 0, false); }
          else { instantChange(variantId, 1, true); }
        } else if (step > 0) {
          instantChange(variantId, cur + 1, true);
        } else if (cur > 0) {
          instantChange(variantId, cur - 1, false);
        }
        return;
      }

      if (!allowMulti) {
        // Legacy behaviour: one of each, tap again to remove.
        if (cur > 0) { delete cardQtys[variantId]; }
        else { cardQtys[variantId] = 1; }
      } else if (step > 0) {
        cardQtys[variantId] = cur + 1;
      } else {
        if (cur <= 1) { delete cardQtys[variantId]; }
        else { cardQtys[variantId] = cur - 1; }
      }

      // Repaint every card for this variant — a product can appear in more than
      // one category, and all of its cards must show the same count.
      paintVariant(variantId);
      updateAddBtn();
    }

    if (track) {
      track.addEventListener('click', function (e) {
        // Ingredients button — never changes the quantity
        if (e.target.closest('.BundlePicker__IngBtn')) return;

        // Expand/collapse detail
        var expandBtn = e.target.closest('.BundlePicker__CardExpandBtn');
        if (expandBtn) {
          var detail = expandBtn.nextElementSibling;
          if (!detail) return;
          var open   = !detail.hidden;
          detail.hidden = open;
          expandBtn.textContent = open ? 'Details +' : 'Details −';
          expandBtn.setAttribute('aria-expanded', String(!open));
          return;
        }

        var card = e.target.closest('.BundlePicker__Card');
        if (!card) return;

        if (e.target.closest('.BundlePicker__CardRemove')) { bumpCard(card, -1); return; }
        if (e.target.closest('.BundlePicker__CardAdd'))    { bumpCard(card,  1); return; }
        // The whole card is the button. Turning that off leaves the photo, the title
        // and the body safe to touch and makes the Add button the only way in — worth
        // it only if stray taps become a complaint, since it also costs the fastest
        // route through a 6-pack. Details and Ingredients already returned above.
        if (!tapCard) return;
        bumpCard(card, 1);
      });

      // Keyboard support (cards are role="button")
      track.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
        var card = e.target.closest('.BundlePicker__Card');
        if (!card) return;
        if (e.target.closest('.BundlePicker__CardExpandBtn') ||
            e.target.closest('.BundlePicker__CardAdd') ||
            e.target.closest('.BundlePicker__CardRemove') ||
            e.target.closest('.BundlePicker__IngBtn')) return;
        if (!tapCard) return;   // see the click handler — Add button only
        e.preventDefault();
        bumpCard(card, 1);
      });
    }

    // ── Add to cart ───────────────────────────────────────────────────────────
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        // Straight-to-cart mode: the products went in as they were picked, so this
        // button just takes the shopper to the cart.
        if (instantAdd) { window.location.href = cartUrl; return; }

        var items = getCartItems();
        if (items.length === 0) return;
        addBtn.disabled  = true;
        addBtn.textContent = 'Adding…';

        function afterAdd() {
          if (activeCode) { fetch('/discount/' + encodeURIComponent(activeCode)); }
          addBtn.textContent = 'Added!';
          setTimeout(function () {
            clearCards();
            if (customise) resetSteppers();
            updateAddBtn();
          }, 1800);
        }
        function onErr() {
          addBtn.disabled   = false;
          addBtn.textContent = 'Error — try again';
          setTimeout(function(){ updateAddBtn(); }, 3000);
        }

        // Use the theme's cart integration when present (opens the cart drawer),
        // otherwise fall back to a plain add + generic refresh event.
        if (typeof window.themeCartAdd === 'function') {
          window.themeCartAdd(items, root.id || 'bundle-picker').then(afterAdd).catch(onErr);
        } else {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: items })
          })
          .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
          .then(function () {
            document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            afterAdd();
          })
          .catch(onErr);
        }
      });
    }

    // ── Sync from Quantity Breaks block ──────────────────────────────────────
    // When the shopper picks a quantity there, auto-select the matching pack here.
    var syncOn = root.getAttribute('data-sync-qty') !== 'false';
    function syncToQty(qty) {
      if (!syncOn || !qty) return;
      var el = root.querySelector('.BundlePicker__Tier[data-qty="' + qty + '"], .BundlePicker__DropItem[data-qty="' + qty + '"]');
      if (!el) return;
      var disc = parseInt(el.getAttribute('data-disc') || '0', 10);
      var code = el.getAttribute('data-discount-code') || '';
      activateTier(qty, disc, code, el);
      // Reflect the selection in the dropdown trigger label, if present.
      var dropValue = root.querySelector('.BundlePicker__DropValue');
      if (dropValue) {
        var label = el.querySelector('.BundlePicker__DropItemLabel');
        var badge = el.querySelector('.BundlePicker__DropItemBadge');
        if (label) dropValue.textContent = label.textContent + (badge ? '  ' + badge.textContent : '');
      }
    }
    if (syncOn) {
      document.addEventListener('qtybreaks:change', function (e) {
        if (e.detail && e.detail.qty) syncToQty(e.detail.qty);
      });
      // Reflect an already-selected quantity on load.
      var qbSel = document.querySelector('.QtyBreaks__Option.is-selected');
      if (qbSel) syncToQty(parseInt(qbSel.getAttribute('data-qty') || '0', 10));
    }

    // Update per-category selected counts — sums quantities, so two of the same
    // scent reads as "2 selected" rather than "1 selected".
    function updateCatCounts() {
      root.querySelectorAll('.BundlePicker__CatGroup').forEach(function (grp) {
        var cnt = 0;
        grp.querySelectorAll('.BundlePicker__Card').forEach(function (c) {
          cnt += cardQtys[c.getAttribute('data-variant-id')] || 0;
        });
        var el = grp.querySelector('.BundlePicker__CatCount');
        if (el) {
          if (!el.hasAttribute('data-original-text')) {
            el.setAttribute('data-original-text', el.textContent);
          }
          el.textContent = cnt > 0 ? cnt + ' selected' : el.getAttribute('data-original-text');
          el.setAttribute('data-cat-count', cnt);
        }
      });
    }

    // Auto-activate first tier and select first card on load
    var firstTier;
    if (mode === 'buttons') {
      firstTier = root.querySelector('.BundlePicker__Tier');
    } else if (mode === 'dropdown') {
      firstTier = root.querySelector('.BundlePicker__DropItem');
    }
    if (firstTier) {
      var aq  = parseInt(firstTier.getAttribute('data-qty')  || '0', 10);
      var ad  = parseInt(firstTier.getAttribute('data-disc') || '0', 10);
      var ac  = firstTier.getAttribute('data-discount-code') || '';
      activateTier(aq, ad, ac, firstTier);
      if (mode === 'dropdown') {
        var _dv = root.querySelector('.BundlePicker__DropValue');
        if (_dv) {
          var _dl = firstTier.querySelector('.BundlePicker__DropItemLabel');
          var _db = firstTier.querySelector('.BundlePicker__DropItemBadge');
          if (_dl) _dv.textContent = _dl.textContent + (_db ? '  ' + _db.textContent : '');
        }
      }
      if (customise && customList) {
        var firstRow = customList.querySelector('.BundlePicker__CustomRow');
        if (firstRow) {
          var rid = firstRow.getAttribute('data-variant-id');
          customQtys[rid] = 1;
          firstRow.classList.add('is-active');
          var rqEl = firstRow.querySelector('.BundlePicker__StepQty');
          if (rqEl) rqEl.textContent = '1';
          updateAddBtn();
        }
      }
      // (No card auto-selected on load — the shopper chooses; keeps the picker starting empty.)
    }

    // ── Category accordion — one open at a time (catGroups defined near top) ──
    function openCatGroup(group) {
      catGroups.forEach(function (g) {
        var isTarget = g === group;
        var ghdr = g.querySelector('.BundlePicker__CatHeader');
        var gpanel = g.querySelector('.BundlePicker__CatProducts');
        var gthumbs = g.querySelector('.BundlePicker__CatThumbs');
        if (isTarget) {
          g.classList.add('is-open');
          if (ghdr) ghdr.setAttribute('aria-expanded', 'true');
          if (gpanel) gpanel.hidden = false;
          if (gthumbs) gthumbs.setAttribute('aria-hidden', 'true');
        } else {
          g.classList.remove('is-open');
          if (ghdr) ghdr.setAttribute('aria-expanded', 'false');
          if (gpanel) gpanel.hidden = true;
          if (gthumbs) gthumbs.setAttribute('aria-hidden', 'false');
        }
      });
    }
    function closeCatGroup(group) {
      var ghdr = group.querySelector('.BundlePicker__CatHeader');
      var gpanel = group.querySelector('.BundlePicker__CatProducts');
      var gthumbs = group.querySelector('.BundlePicker__CatThumbs');
      group.classList.remove('is-open');
      if (ghdr) ghdr.setAttribute('aria-expanded', 'false');
      if (gpanel) gpanel.hidden = true;
      if (gthumbs) gthumbs.setAttribute('aria-hidden', 'false');
    }
    catGroups.forEach(function (grp) {
      var hdr = grp.querySelector('.BundlePicker__CatHeader');
      if (!hdr) return;
      function toggleCat() {
        // Proper toggle: collapse if already open, otherwise open (and close the others)
        if (grp.classList.contains('is-open')) {
          closeCatGroup(grp);
        } else {
          openCatGroup(grp);
        }
      }
      hdr.addEventListener('click', toggleCat);
      hdr.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleCat(); }
      });
      // Clicking the collapsed-state thumbnail strip expands that category
      var thumbsEl = grp.querySelector('.BundlePicker__CatThumbs');
      if (thumbsEl) {
        thumbsEl.addEventListener('click', function () {
          if (!grp.classList.contains('is-open')) openCatGroup(grp);
        });
      }
    });

    // ── Ingredients panel ─────────────────────────────────────────────────────
    // Content comes from the Botanical Cards blocks already on the page: each one
    // publishes a JSON island keyed by the product or collection it belongs to, so
    // whatever a product shows under "Key Ingredients" is what shows here — no
    // second place for the merchant to keep up to date.
    if (ingOn) initIngredients();

    function initIngredients() {
      var panel = root.querySelector('.BundlePicker__IngPanel');
      if (!panel) return;

      var backdrop = root.querySelector('.BundlePicker__IngBackdrop');
      var listEl   = panel.querySelector('.BundlePicker__IngList');
      var titleEl  = panel.querySelector('.BundlePicker__IngTitle');
      var prodEl   = panel.querySelector('.BundlePicker__IngProduct');
      var hintEl   = panel.querySelector('.BundlePicker__IngScrollHint');
      var closeBtn = panel.querySelector('.BundlePicker__IngClose');

      // Build the lookup: product handle wins over collection, collection over "all".
      var byProduct = {}, byCollection = {}, forAll = null;
      document.querySelectorAll('script.BundlePickerIngData').forEach(function (node) {
        var data;
        try { data = JSON.parse(node.textContent); } catch (err) { return; }
        if (!data || !data.items || !data.items.length) return;
        var scope = node.getAttribute('data-scope');
        var key   = node.getAttribute('data-key') || '';
        if (scope === 'product' && key) byProduct[key] = data;
        else if (scope === 'collection' && key) byCollection[key] = data;
        else if (scope === 'all' && !forAll) forAll = data;
      });

      var rows = [].slice.call(root.querySelectorAll('.BundlePicker__Card, .BundlePicker__CustomRow'));

      function colsOf(el) {
        return (el.getAttribute('data-collections') || '').trim().split(/\s+/).filter(Boolean);
      }

      // How many products in this picker sit in each collection. A product is
      // usually in both a broad collection ("all blends") and a narrow one
      // ("grounded"); the narrow one is the better description of it, so when a
      // product matches more than one ingredient set we take the least-shared.
      var reach = {};
      rows.forEach(function (el) {
        colsOf(el).forEach(function (h) { reach[h] = (reach[h] || 0) + 1; });
      });

      function lookup(el) {
        var handle = el.getAttribute('data-handle');
        if (handle && byProduct[handle]) return byProduct[handle];
        var best = null, bestReach = Infinity;
        colsOf(el).forEach(function (h) {
          if (!byCollection[h]) return;
          var r = reach[h] || 0;
          if (r < bestReach) { best = byCollection[h]; bestReach = r; }
        });
        return best || forAll;
      }

      // Reveal the trigger only where there is something to show.
      var triggers = [];
      rows.forEach(function (el) {
        var btn = el.querySelector('.BundlePicker__IngBtn');
        if (!btn) return;
        var data = lookup(el);
        if (!data) return;
        btn.hidden = false;
        triggers.push({ el: el, btn: btn, data: data });
      });
      if (!triggers.length) return;

      var openFor = null;
      var hoverTimer = null;
      var warmed = [];
      function warm(trigger) {
        if (warmed.indexOf(trigger) > -1) return;
        warmed.push(trigger);
        trigger.data.items.forEach(function (item) {
          if (item.i) { var im = new Image(); im.src = item.i; }
        });
      }
      // Some mobile browsers wrongly claim to support hover, and a tap then fires a
      // synthetic mouseenter — which was making the panel appear while shoppers were
      // just scrolling. The moment we see a real touch, hover opening is off for good.
      var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches
                     && !('ontouchstart' in window) && !(navigator.maxTouchPoints > 0);
      document.addEventListener('touchstart', function () { canHover = false; }, { passive: true, capture: true });
      function isSheet() { return window.innerWidth < 750; }

      function render(data, name) {
        if (prodEl)  prodEl.textContent  = name || '';
        if (titleEl) titleEl.textContent = data.title || 'Ingredients';
        listEl.textContent = '';
        data.items.forEach(function (item) {
          var row = document.createElement('div');
          row.className = 'BundlePicker__IngItem';
          if (item.i) {
            var wrap = document.createElement('span');
            wrap.className = 'BundlePicker__IngImg';
            var img = document.createElement('img');
            img.src = item.i;
            img.alt = '';
            wrap.appendChild(img);
            row.appendChild(wrap);
          }
          var body = document.createElement('span');
          body.className = 'BundlePicker__IngText';
          if (item.n) {
            var nm = document.createElement('strong');
            nm.className = 'BundlePicker__IngName';
            nm.textContent = item.n;
            body.appendChild(nm);
          }
          if (item.d) {
            var ds = document.createElement('span');
            ds.className = 'BundlePicker__IngDesc';
            ds.textContent = item.d;
            body.appendChild(ds);
          }
          row.appendChild(body);
          listEl.appendChild(row);
        });
        listEl.scrollTop = 0;
      }

      // Anchor the popover to the card, choosing whichever side actually has room
      // and shrinking it to fit when neither side can take it whole. Recomputed on
      // every scroll, so the panel flips above/below to stay on screen as the page
      // moves rather than sliding out of view.
      var GAP = 8, EDGE = 12, MIN_H = 150;
      function position(anchor) {
        if (isSheet()) {
          panel.style.top = ''; panel.style.left = ''; panel.style.maxHeight = '';
          panel.classList.remove('is-above');
          return;
        }
        var rootBox = root.getBoundingClientRect();
        var box     = anchor.getBoundingClientRect();
        var vh      = window.innerHeight;

        // Horizontal: centred on the card, kept inside the picker
        panel.style.maxHeight = '';            // measure at natural height first
        var width   = panel.offsetWidth;
        var left    = box.left - rootBox.left + (box.width / 2) - (width / 2);
        var maxLeft = rootBox.width - width - 4;
        if (left > maxLeft) left = maxLeft;
        if (left < 4) left = 4;
        panel.style.left = left + 'px';

        // Never taller than the window, so it can always be shown whole with the
        // ingredient list scrolling inside it.
        var cap = Math.max(MIN_H, vh - (EDGE * 2));
        if (panel.offsetHeight > cap) panel.style.maxHeight = cap + 'px';
        var panelH = panel.offsetHeight;

        // Sit on whichever side of the card has more room.
        var below = vh - box.bottom - GAP - EDGE;
        var above = box.top - GAP - EDGE;
        var placeAbove;
        if (panelH <= below)      placeAbove = false;
        else if (panelH <= above) placeAbove = true;
        else                      placeAbove = above > below;

        // Then clamp into the viewport. Without this the panel follows a card that
        // has scrolled off the screen and goes with it — "above" a card that is
        // below the fold is still below the fold.
        var topVp  = placeAbove ? box.top - panelH - GAP : box.bottom + GAP;
        var maxTop = vh - EDGE - panelH;
        if (topVp > maxTop) topVp = maxTop;
        if (topVp < EDGE)   topVp = EDGE;

        panel.style.top = (topVp - rootBox.top) + 'px';
        panel.classList.toggle('is-above', placeAbove);
      }

      // Only prompt to scroll when there is genuinely something below the fold,
      // and drop the prompt once the shopper has reached the end.
      function updateHint() {
        if (!hintEl) return;
        var overflows = listEl.scrollHeight > listEl.clientHeight + 4;
        var atBottom  = listEl.scrollTop + listEl.clientHeight >= listEl.scrollHeight - 4;
        hintEl.hidden = !overflows || atBottom;
        // A hover preview is click-through, so telling the shopper to scroll it
        // would be asking for something they can't do yet.
        hintEl.textContent = pinned ? 'Scroll for more' : 'Click for the full list';
      }
      listEl.addEventListener('scroll', updateHint, { passive: true });

      // A panel opened by hovering closes itself when the pointer moves away. One
      // the shopper actually clicked stays put until they dismiss it, so clicking
      // the button on a panel that hover already opened doesn't snap it shut.
      var pinned = false;

      // The theme's own drawers lock the page with this attribute; reuse it so the
      // sheet and the cart drawer can't fight over the body scroll. Only ever
      // release a lock we put on ourselves — clearing it blindly would unlock the
      // page underneath an open cart drawer.
      var weLockedPage = false;
      function lockPage(on) {
        if (on === weLockedPage) return;
        weLockedPage = on;
        if (on) document.documentElement.setAttribute('scroll-lock', '');
        else document.documentElement.removeAttribute('scroll-lock');
      }

      // Decide what the panel currently is. The small desktop popover is a preview:
      // click-through, no backdrop, page still scrollable. The bottom sheet is a real
      // modal and must ALWAYS take pointer events — a sheet that is click-through has
      // an inert close button and traps the shopper, so sheet always implies pinned.
      function applyMode() {
        var sheet = isSheet();
        if (sheet) pinned = true;
        panel.classList.toggle('is-sheet', sheet);
        panel.classList.toggle('is-pinned', pinned);
        if (backdrop) backdrop.hidden = !sheet;
        lockPage(sheet);
        return sheet;
      }

      function open(trigger, byClick) {
        render(trigger.data, (trigger.el.getAttribute('data-title') || ''));
        panel.hidden = false;
        pinned = !!byClick;
        var sheet = applyMode();
        position(trigger.el);
        if (hintEl) hintEl.hidden = true;
        // Measure once the panel has actually been laid out, so a short list never
        // flashes the prompt.
        requestAnimationFrame(updateHint);
        triggers.forEach(function (t) { t.btn.setAttribute('aria-expanded', String(t === trigger)); });
        openFor = trigger;
        // On a phone the sheet covers the page, so move focus into it.
        if (sheet && closeBtn) closeBtn.focus();
      }

      function close() {
        if (!openFor) return;
        var returnFocus = panel.contains(document.activeElement) ? openFor.btn : null;
        panel.style.transition = '';
        panel.style.transform = '';
        if (backdrop) backdrop.style.opacity = '';
        panel.hidden = true;
        // Drop both mode classes so the element's state matches reality while closed
        // and nothing is left relying on the [hidden] rule alone.
        panel.classList.remove('is-pinned');
        panel.classList.remove('is-sheet');
        if (backdrop) backdrop.hidden = true;
        lockPage(false);
        triggers.forEach(function (t) { t.btn.setAttribute('aria-expanded', 'false'); });
        openFor = null;
        pinned  = false;
        if (returnFocus) returnFocus.focus();
      }

      triggers.forEach(function (trigger) {
        // Touching or tabbing to a product is enough intent to start fetching its
        // thumbnails — by the time the panel opens they are usually already there.
        trigger.el.addEventListener('pointerenter', function () { warm(trigger); });
        trigger.el.addEventListener('focusin',      function () { warm(trigger); });

        trigger.btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          clearTimeout(hoverTimer);
          if (openFor === trigger && pinned) close();
          else open(trigger, true);
        });

        if (!ingOnHover) return;
        trigger.el.addEventListener('mouseenter', function () {
          // At mobile widths the panel is a full-screen sheet. Raising one because a
          // cursor drifted over a card is wrong even when it closes properly, so
          // hover only ever opens the small desktop popover.
          if (!canHover || pinned || isSheet()) return;
          clearTimeout(hoverTimer);
          hoverTimer = setTimeout(function () {
            if (isSheet()) return;
            open(trigger, false);
          }, 350);
        });
        trigger.el.addEventListener('mouseleave', function () {
          if (!canHover || pinned) return;
          clearTimeout(hoverTimer);
          // Give the shopper a moment to move the pointer onto the panel to scroll it.
          hoverTimer = setTimeout(function () {
            if (openFor === trigger && !pinned && !panel.matches(':hover')) close();
          }, 220);
        });
      });

      if (ingOnHover) {
        panel.addEventListener('mouseenter', function () { clearTimeout(hoverTimer); });
        panel.addEventListener('mouseleave', function () {
          if (!canHover || pinned) return;
          hoverTimer = setTimeout(function () { if (!pinned) close(); }, 220);
        });
      }

      // Closing on `click` leaves the browser free to replay the tap as a mouse
      // click once the panel is gone — which landed on the product card underneath
      // and added another item. Handling touchend and preventing its default stops
      // that replay from ever being generated.
      function dismissOnTouch(el) {
        if (!el) return;
        el.addEventListener('touchend', function (e) {
          if (!openFor) return;
          e.preventDefault();
          e.stopPropagation();
          close();
        }, { passive: false });
      }
      dismissOnTouch(closeBtn);
      dismissOnTouch(backdrop);

      if (closeBtn) closeBtn.addEventListener('click', function (e) { e.stopPropagation(); close(); });

      // Swipe the sheet down to dismiss it. The grab handle looks draggable, so it
      // has to actually drag — otherwise a shopper who tries it concludes they are
      // stuck. Only the handle and the header start a drag, so scrolling the
      // ingredient list is unaffected.
      var grabEl = panel.querySelector('.BundlePicker__IngGrab');
      var headEl = panel.querySelector('.BundlePicker__IngHead');
      var dragFrom = null, dragBy = 0;

      panel.addEventListener('touchstart', function (e) {
        if (!panel.classList.contains('is-sheet') || e.touches.length !== 1) return;
        var target = e.target;
        if (!(grabEl && grabEl.contains(target)) && !(headEl && headEl.contains(target))) return;
        dragFrom = e.touches[0].clientY;
        dragBy = 0;
        panel.style.transition = 'none';
      }, { passive: true });

      panel.addEventListener('touchmove', function (e) {
        if (dragFrom === null) return;
        var dy = e.touches[0].clientY - dragFrom;
        if (dy < 0) dy = 0;
        dragBy = dy;
        panel.style.transform = 'translateY(' + dy + 'px)';
        if (backdrop) backdrop.style.opacity = String(Math.max(0, 1 - dy / 320));
        if (dy > 4) e.preventDefault();
      }, { passive: false });

      function endDrag(e) {
        if (dragFrom === null) return;
        var dy = dragBy;
        dragFrom = null; dragBy = 0;
        panel.style.transition = '';
        panel.style.transform = '';
        if (backdrop) backdrop.style.opacity = '';
        if (dy > 90) {
          if (e && e.cancelable) e.preventDefault();  // no replayed click on the card below
          close();
        }
      }
      panel.addEventListener('touchend', endDrag, { passive: false });
      panel.addEventListener('touchcancel', endDrag);
      if (backdrop) backdrop.addEventListener('click', close);
      document.addEventListener('click', function (e) {
        if (!openFor) return;
        if (panel.contains(e.target) || e.target.closest('.BundlePicker__IngBtn')) return;
        close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && openFor) {
          var btn = openFor.btn;
          close();
          btn.focus();
        }
      });
      window.addEventListener('resize', function () {
        if (!openFor) { lockPage(false); return; }
        // A popover that becomes a sheet because the window narrowed has to be
        // promoted to a proper modal, not left as an inert click-through panel.
        applyMode();
        position(openFor.el);
        updateHint();
        // The panel is positioned relative to the picker, so a reflow triggered by
        // the resize can shift it after we measured. Re-run once the layout settles.
        requestAnimationFrame(function () { if (openFor) position(openFor.el); });
        setTimeout(function () { if (openFor) { position(openFor.el); updateHint(); } }, 150);
      });
      // Keep the popover glued to its card while the page scrolls, re-deciding which
      // side it sits on each time so it never ends up off screen.
      var scrollQueued = false;
      window.addEventListener('scroll', function () {
        if (!openFor || isSheet() || scrollQueued) return;
        scrollQueued = true;
        requestAnimationFrame(function () {
          scrollQueued = false;
          if (!openFor || isSheet()) return;
          position(openFor.el);
          updateHint();
        });
      }, { passive: true });
    }

    // Init add btn state
    updateAddBtn();

    // Straight-to-cart mode has to survive a reload: the products really are in the
    // cart, so read them back rather than showing a bare "Add" on something the
    // shopper has already put there. Skipped if they got a tap in first, so the
    // seed can never double-count what instantChange() has already recorded.
    if (instantAdd && typeof window.themeCartGet === 'function') {
      window.themeCartGet().then(function (cart) {
        if (Object.keys(cardQtys).length) return;
        var seeded = false;
        (cart && cart.items ? cart.items : []).forEach(function (it) {
          var id = String(it.variant_id);
          if (!root.querySelector('.BundlePicker__Card[data-variant-id="' + id + '"]')) return;
          cardQtys[id] = (cardQtys[id] || 0) + it.quantity;
          seeded = true;
        });
        if (!seeded) return;
        Object.keys(cardQtys).forEach(function (id) { paintVariant(id); });
        updateAddBtn();
      }).catch(function () { /* cart unreadable — the picker still works from zero */ });
    }
  }
})();
